module.exports = __webpack_public_path__ + "static/img/preliminary-round-no2.da03c0fa.png";